module.exports = __webpack_public_path__ + "img_8.jpg?44c1e242b19c0b19f00191b8f6516cd3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_8.jpg
// module id = 517
// module chunks = 2